import LoadingSpinner from "app/components/LoadingSpinner/LoadingSpinner";
import cloneDeep from "lodash/cloneDeep";
import includes from "lodash/includes";
import React, { Component } from "react";
import type { IntlShape } from "react-intl";
import { injectIntl } from "react-intl";
import { connect } from "react-redux";
import "./AsianLeaguesSelector.scss";
import CompetitionsHeader from "./components/CompetitionsHeader/CompetitionsHeader";
import CompetitionsLists from "./components/CompetitionsLists/CompetitionsLists";
import CompetitionsSubmit from "./components/CompetitionsSubmit/CompetitionsSubmit";
type Props = {
  sportId: number;
  selectLeagues: (...args: Array<any>) => any;
  showLeaguesSelector: boolean;
  toggleLeaguesSelector: (...args: Array<any>) => any;
  orderBy: String;
  intl: IntlShape;
  asianPreGameEventsOnly: boolean;
  selectedDate: string;
  compIds: number[];
  getLeagues: (...args: Array<any>) => any;
  popularCompetitions: Record<string, any>;
  otherCompetitions: Record<string, any>;
  selectedComps: Record<string, any>;
  totalNumberComps: number;
  showComponent: boolean;
  selectAll: boolean;
  updateSelectedComps: (...args: Array<any>) => any;
  isLoading: boolean;
  setFilter: (payload: { [key: string]: any }) => void;
  setFilters: (payload: { [key: string]: any }[]) => void;
  selectedSportTimeFrame: string | null;
};

class AsianLeaguesSelector extends Component<Props> {
  node: any;

  componentDidMount() {
    document.addEventListener("mousedown", this.handleClick, false);
    this.props.getLeagues();
  }

  componentDidUpdate(prevProps) {
    const { selectedComps, selectLeagues, getLeagues } = this.props;
    if (
      prevProps.orderBy !== this.props.orderBy ||
      prevProps.selectedSportTimeFrame !== this.props.selectedSportTimeFrame ||
      prevProps.sportId !== this.props.sportId ||
      prevProps.selectedDate !== this.props.selectedDate
    ) {
      getLeagues();
    } else if (
      prevProps.asianPreGameEventsOnly !== this.props.asianPreGameEventsOnly &&
      prevProps.sportId === this.props.sportId
    ) {
      selectLeagues(selectedComps);
    } else if (
      prevProps.asianPreGameEventsOnly !== this.props.asianPreGameEventsOnly &&
      prevProps.sportId !== this.props.sportId
    ) {
      getLeagues();
    } else if (prevProps.sportId !== this.props.sportId) {
      getLeagues();
    }
  }

  componentWillUnmount() {
    document.removeEventListener("mousedown", this.handleClick, false);
  }

  handleClick = (e: any) => {
    // Hide component if there is a click outside the component
    if (
      this.node &&
      !this.node.contains(e.target) &&
      e.target.className?.indexOf("leagues-button") === -1
    ) {
      this.hideComponent();
    }
  };
  toggleAllComps = () => {
    const {
      selectAll,
      selectedComps,
      popularCompetitions,
      otherCompetitions,
      updateSelectedComps,
    } = this.props;

    if (selectAll) {
      let cloneSelectedComps = cloneDeep(selectedComps);
      cloneSelectedComps.length = 0;
      updateSelectedComps(!selectAll, cloneSelectedComps);
    } else {
      const popularCompsIds =
        popularCompetitions && popularCompetitions.map(comp => comp.id);
      const otherCompsIds =
        otherCompetitions && otherCompetitions.map(comp => comp.id);
      updateSelectedComps(!selectAll, popularCompsIds.concat(otherCompsIds));
    }
  };
  handleSubmit = () => {
    const {
      selectedComps,
      totalNumberComps,
      selectLeagues,
      toggleLeaguesSelector,
    } = this.props;
    toggleLeaguesSelector(); //hide this component

    // check if no comps selected
    if (selectedComps && selectedComps.length === 0) {
      // do nothing
      return;
    }
    this.props.setFilters([
      { singleSelectedCompetitionId: null },
      { selectedCompetitionIds: null },
    ]);
    // Update filters only if not all competitions are selected
    // ie sending no competitions will return all competitions
    if (selectedComps.length !== totalNumberComps) {
      this.props.setFilters([{ selectedCompetitionIds: selectedComps }]);
    }
    // Trigger fetch in AsianCompetitionsScreen
    selectLeagues();
  };
  hideComponent = () => {
    this.props.toggleLeaguesSelector(); //hide this component
  };
  toggleLeagueSelected = id => {
    const { selectedComps, totalNumberComps, updateSelectedComps } = this.props;
    let cloneSelectedComps = cloneDeep(selectedComps);

    if (includes(cloneSelectedComps, id)) {
      cloneSelectedComps = cloneSelectedComps.filter(compId => {
        return compId !== id;
      });
    } else {
      cloneSelectedComps.push(id);
    }

    const selectAll =
      cloneSelectedComps.length === totalNumberComps ? true : false;
    updateSelectedComps(selectAll, cloneSelectedComps);
  };

  render() {
    const {
      popularCompetitions,
      otherCompetitions,
      selectedComps,
      selectAll,
      isLoading,
    } = this.props;
    // if (!this.props.showLeaguesSelector) return <div></div>;
    return (
      <div
        className="select-competitions-container"
        ref={node => (this.node = node)}
      >
        <div className="select-competitions">
          <CompetitionsHeader
            selectAll={selectAll}
            toggleAllComps={this.toggleAllComps}
            hideComponent={this.hideComponent}
            intl={this.props.intl}
          />
          {isLoading ? (
            <LoadingSpinner />
          ) : (
            <React.Fragment>
              <CompetitionsLists
                popularCompetitions={popularCompetitions}
                otherCompetitions={otherCompetitions}
                selectedComps={selectedComps}
                intl={this.props.intl}
                toggleLeagueSelected={this.toggleLeagueSelected}
              />
              <CompetitionsSubmit
                selectedComps={selectedComps}
                intl={this.props.intl}
                handleSubmit={this.handleSubmit}
              />
            </React.Fragment>
          )}
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  unfilteredCompetitionCount:
    state.competitionListModel.unfilteredCompetitionCount,
  filteredCompetitionCount: state.competitionListModel.filteredCompetitionCount,
  type: state.competitionListModel.type,
  sportId: state.competitionListModel.sportId,
  orderBy: state.asianCompetitionListFiltersModel.orderBy,
  asianPreGameEventsOnly:
    state.asianCompetitionListFiltersModel.asianPreGameEventsOnly,
  selectedDate: state.asianCompetitionListFiltersModel.selectedDate,
  popularCompetitions: state.leaguesModel.popularCompetitions,
  otherCompetitions: state.leaguesModel.otherCompetitions,
  selectedComps: state.leaguesModel.selectedComps,
  totalNumberComps: state.leaguesModel.totalNumberComps,
  showComponent: state.leaguesModel.showComponent,
  selectAll: state.leaguesModel.selectAll,
  isLoading: state.leaguesModel.isLoading,
  selectedSportTimeFrame: state.sportsSelectionListModel.selectedSportTimeFrame,
});

const mapDispatchToProps = (dispatch: any) => ({
  getLeagues: () => {
    dispatch.leaguesModel.getLeagues();
  },
  setFilter: payload => {
    dispatch.asianCompetitionListFiltersModel.setFilter(payload);
  },
  setFilters: (payload: { [key: string]: boolean | string | null }[]) => {
    dispatch.asianCompetitionListFiltersModel.setFilters(payload);
  },
  updateSelectedComps: (
    selectAll: boolean,
    selectedComps: Record<string, any>
  ) => {
    dispatch.leaguesModel.updateSelectedComps({
      selectAll,
      selectedComps,
    });
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(injectIntl(AsianLeaguesSelector)) as any;
